(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["EYES-Responsive-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eyesplus-video-hero')) {
    customElements.define(
      'eyesplus-video-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video')
          this.toggle = this.querySelector('[data-video-toggle]')
          this.mobileQuery = window.matchMedia('(max-width: 749px)')
          this.reducedMotionQuery = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          )

          this.handleViewportChange = this.loadVideo.bind(this)

          this.mobileQuery.addEventListener(
            'change',
            this.handleViewportChange
          )

          this.loadVideo()

          if (this.toggle && this.video) {
            this.toggle.addEventListener('click', () => {
              if (this.video.paused) {
                this.video.play()
                this.toggle.setAttribute(
                  'aria-label',
                  this.toggle.dataset.pauseLabel
                )
                this.toggle.querySelector('span').textContent = 'Ⅱ'
              } else {
                this.video.pause()
                this.toggle.setAttribute(
                  'aria-label',
                  this.toggle.dataset.playLabel
                )
                this.toggle.querySelector('span').textContent = '▶'
              }
            })
          }
        }

        disconnectedCallback() {
          if (this.mobileQuery && this.handleViewportChange) {
            this.mobileQuery.removeEventListener(
              'change',
              this.handleViewportChange
            )
          }
        }

        loadVideo() {
          if (!this.video) return

          const template = this.mobileQuery.matches
            ? this.querySelector('template[data-mobile-video]')
            : this.querySelector('template[data-desktop-video]')

          if (!template) return

          this.video.pause()
          this.video.replaceChildren(template.content.cloneNode(true))
          this.video.load()

          if (!this.reducedMotionQuery.matches) {
            const playRequest = this.video.play()

            if (playRequest) {
              playRequest.catch(() => {})
            }
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyes-care-plans-daily-cost"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.eyes-daily-cost-section').forEach(function(section){var target=document.querySelector('.ecp-plan-list');if(target&&target.parentNode){target.insertAdjacentElement('afterend',section);}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-product')) {
    customElements.define(
      'premium-product',
      class extends HTMLElement {
        connectedCallback() {
          this.mainImage = this.querySelector('[data-main-image]')
          this.select = this.querySelector('[data-variant-select]')
          this.price = this.querySelector('[data-price]')
          this.compare = this.querySelector('[data-compare-price]')
          this.stickyPrice = this.querySelector('[data-sticky-price]')
          this.addButton = this.querySelector('[data-add-button]')
          this.addLabel = this.querySelector('[data-add-label]')

          this.querySelectorAll('[data-thumbnail]').forEach(button => {
            button.addEventListener('click', () => {
              if (this.mainImage) {
                this.mainImage.src = button.dataset.imageUrl
              }

              this.querySelectorAll('[data-thumbnail]').forEach(item => {
                item.classList.remove('is-active')
              })

              button.classList.add('is-active')
            })
          })

          if (this.select) {
            this.select.addEventListener('change', () => {
              const option = this.select.selectedOptions[0]
              const available = option.dataset.available === 'true'

              this.price.textContent = option.dataset.price
              this.stickyPrice.textContent = option.dataset.price
              this.compare.textContent = option.dataset.comparePrice
              this.compare.hidden = !option.dataset.comparePrice
              this.addButton.disabled = !available
              this.addLabel.textContent = available
                ? 'Add to cart'
                : 'Sold out'

              if (option.dataset.image && this.mainImage) {
                this.mainImage.src = option.dataset.image
              }
            })
          }

          this.querySelector('[data-sticky-add]')?.addEventListener(
            'click',
            () => {
              if (this.addButton) {
                this.addButton.click()
              }
            }
          )
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-loop-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-marquee')) {
    customElements.define(
      'ugc-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = [...this.querySelectorAll('video')]

          this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                const video = entry.target

                if (entry.isIntersecting) {
                  const request = video.play()

                  if (request) {
                    request.catch(() => {})
                  }
                } else {
                  video.pause()
                }
              })
            },
            {
              threshold: 0.35
            }
          )

          this.videos.forEach(video => {
            this.observer.observe(video)
          })

          this.querySelectorAll('[data-sound-toggle]').forEach(button => {
            button.addEventListener('click', () => {
              const video = button.parentElement.querySelector('video')

              if (!video) return

              this.videos.forEach(item => {
                if (item !== video) {
                  item.muted = true
                }
              })

              video.muted = !video.muted

              button.querySelector('span').textContent = video.muted
                ? '🔇'
                : '🔊'

              button.setAttribute(
                'aria-label',
                video.muted
                  ? 'Play video with sound'
                  : 'Mute video'
              )

              this.classList.toggle('is-paused', !video.muted)
            })
          })
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect()
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
